import { useAuth } from "../services/AuthProvider"
import { UnauthedImageSelector } from "./UnauthedImageSelector"

export const UserImageSelector:React.FC<{fileName:string, fallbackImageURL:string, [key:string]:any}> = ({fileName, fallbackImageURL, ...props}) => {
  const { currentUser } = useAuth();
  const uid = currentUser?.uid || "NO_USER_IDENTIFIED";

  return <UnauthedImageSelector fileName={"user/" + uid + "/" + fileName} fallbackImageURL={fallbackImageURL} {...props}/>
}